import { useState } from 'react';
import {
  plansListCapitalGain,
  plansListNRI,
  salariedPlansList,
} from '../../../constants/itrContants';
import { If } from '../../Atoms/Conditionals';
import { MarktechModal } from '../../Atoms/Modal';
import { TPricingPlans } from '../../S/pricing/types';
import { extractPlanWFromId } from '../../Utils/CommonUtils';
import {
  CAPITAL_GAIN_CARD_DATA,
  NRI_INCOME,
  SALARIED_CARD_DATA,
  SHOW_ICON,
} from './cardDataConstant';
import { PricingCard, TCardData } from './pricing-card';

interface IPRICE_TABLE_HEADER_PROPS {
  planName: string;
  finalPrice: number;
  originalPrice?: number;
  itr: string;
  showTaxExcluded?: boolean;
  planId: string;
  priceMapData: Record<string, TPricingPlans>;
}

export const PriceTableHeader = ({
  planName,
  finalPrice,
  originalPrice,
  itr,
  showTaxExcluded = true,
  planId,
  priceMapData,
}: IPRICE_TABLE_HEADER_PROPS): JSX.Element => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [cardData, setCardData] = useState({});

  const salariedPlanData = extractPlanWFromId(salariedPlansList, priceMapData);
  const capitalGainPlanData = extractPlanWFromId(
    plansListCapitalGain,
    priceMapData
  );
  const NRIPlanData = extractPlanWFromId(plansListNRI, priceMapData);

  const togglePlanModal = (id: string) => {
    setIsPopupVisible(!isPopupVisible);
    if (id === 'prod_self_itr_1') {
      setCardData({
        priceRange: SALARIED_CARD_DATA,
        planData: salariedPlanData,
      });
    } else if (id === 'prod_self_itr_2') {
      setCardData({
        priceRange: CAPITAL_GAIN_CARD_DATA,
        planData: capitalGainPlanData,
      });
    } else if (id === 'prod_self_itr_6') {
      setCardData({
        priceRange: NRI_INCOME,
        planData: NRIPlanData,
      });
    }
  };
  return (
    <>
      <div className="text-grey-900 text-s-14 font-medium pb-2 sm:text-s-12 xl:h-14 lg:h-14 md:h-14 sm:h-fit">
        {planName}
      </div>
      <div className="h-[21px]">
        <If condition={!!SHOW_ICON[planId]}>
          <p className="text-s-14 font-medium text-grey-700 flex">
            Starting at
            <img
              onClick={() => togglePlanModal(planId)}
              className="w-5 h-5 cursor-pointer ml-1"
              src="https://assets.clear.in/cleartax/images/1689856762_info2.png"
              alt="tooltip icon"
            />
          </p>
        </If>
      </div>

      <div className="text-grey-900 text-s-24 font-semibold sm:text-base whitespace-nowrap">
        ₹ {finalPrice}
      </div>

      <div
        className={`text-grey-700 text-base font-normal line-through sm:text-s-12 ${
          originalPrice ? '' : 'invisible'
        }`}
      >
        ₹ {originalPrice}
      </div>

      <div
        className={`text-s-10 text-grey-500 font-light  pb-4 sm:pb-2 ${
          showTaxExcluded ? '' : 'invisible'
        }`}
      >
        *excl. of taxes
      </div>

      <div className="bg-[#0E4EA2] text-white rounded-sm px-2 py-1 text-base font-semibold w-fit sm:text-s-10 whitespace-nowrap">
        {itr}
      </div>
      <MarktechModal
        open={isPopupVisible}
        onClose={() => {
          togglePlanModal(planId);
        }}
        closeIcon={'✕'}
        classNames={{
          modal:
            'mobile-search-box rounded-2xl sm:w-11/12 rounded-2xl h-fit max-h-[90vh] overflow-hidden',
          closeIcon: 'absolute',
        }}
        center
      >
        <PricingCard cardData={cardData as TCardData} />
      </MarktechModal>
    </>
  );
};
